module.exports = __webpack_public_path__ + "static/media/BRA.8f72874e.svg";